const configuredApiUrl = import.meta.env.VITE_API_URL?.trim();

export const API_BASE_URL = configuredApiUrl || window.location.origin;

function getStoredToken(): string | null {
  try {
    const raw = window.localStorage.getItem("hmo-manager-auth");
    if (!raw) return null;
    const parsed = JSON.parse(raw);
    return parsed?.token ?? null;
  } catch {
    return null;
  }
}

export function getAuthToken(): string | null {
  return getStoredToken();
}

export async function request<T>(path: string, init?: RequestInit): Promise<T> {
  const method = (init?.method ?? "GET").toUpperCase();
  const hasBody = typeof init?.body === "string" && init.body.length > 0;
  const shouldSetJsonContentType =
    method !== "GET" && method !== "HEAD" && method !== "DELETE" && hasBody;

  const headers = new Headers(init?.headers);
  if (shouldSetJsonContentType && !headers.has("Content-Type")) {
    headers.set("Content-Type", "application/json");
  }

  if (!headers.has("Authorization")) {
    const token = getStoredToken();
    if (token) {
      headers.set("Authorization", `Bearer ${token}`);
    }
  }

  const response = await fetch(`${API_BASE_URL}${path}`, {
    ...init,
    headers,
  });

  if (response.status === 401) {
    if (getStoredToken()) {
      window.localStorage.removeItem("hmo-manager-auth");
      window.location.reload();
      throw new Error("Session expired");
    }
  }

  if (!response.ok) {
    let message = "Request failed";

    try {
      const text = await response.text();
      const parsed = JSON.parse(text);
      message = parsed?.error || parsed?.message || text || message;
    } catch {
      // non-JSON response, message stays default
    }

    throw new Error(message);
  }

  if (response.status === 204) {
    return undefined as T;
  }

  return response.json() as Promise<T>;
}

export default request;
